import { useContext, useMemo } from "react";
import { isEmpty } from "lodash";
import { motion } from "framer-motion";
import { Text } from "@mantine/core";

import type { Message } from "wall/types/message.model";
import { config } from "config";
import { getImageUrl } from "common/utils/getImageUrl";
import { WallContext } from "wall/hooks/useWall";
import { DEFAULT_WHITE_COLOR } from "../../../../_graphic_design";

function AnimatedMessage({ message }: { message: Message }) {
  const wall = useContext(WallContext);

  const styles = useMemo(
    () =>
      !isEmpty(wall) && wall.colors
        ? {
            message: {
              color: wall.colors.messages,
              fontSize: wall.msgFontSize,
              lineHeight: wall.msgLineHeight || "80px",
            },
            author: {
              color: wall.colors.authors,
              fontSize: wall.msgAuthorFontSize,
            },
          }
        : {
            message: { color: DEFAULT_WHITE_COLOR, fontSize: "60px" },
            author: { color: DEFAULT_WHITE_COLOR, fontSize: "40px" },
          },
    [wall],
  );
  return (
    <motion.div
      initial={{ scale: 0.5, opacity: 0, x: "100vh" }}
      animate={{ scale: 1, opacity: 1, x: 0 }}
      exit={{ scale: 0.5, opacity: 0, x: "-100vh" }}
      transition={{ duration: 0.5, ease: "easeIn" }}
      className={`flex gap-3 items-center ${wall.slideShowStructure === "left-photo" ? "flex-row-reverse" : "flex-row"}`}
    >
      {message.imageKey && (
        <img
          className="max-h-[80vh] max-w-[35vw] min-w-0 object-contain rounded-2xl"
          src={getImageUrl(message.imageKey)}
          alt="Non trouvée"
        />
      )}

      <div className={"p-10"}>
        <Text
          className={`leading-[70px] mb-3 ${wall?.isMsgBold && "font-bold"}`}
          sx={styles.message}
        >
          {wall?.isMsgUppercase
            ? message.message
                .substring(0, config.walls.maxMessageSize)
                .toUpperCase()
            : message.message.substring(0, config.walls.maxMessageSize)}{" "}
        </Text>
        <Text
          className={`text-right font-bold ${wall?.isAuthorBold && "font-bold"}`}
          sx={styles.author}
        >
          {wall?.isAuthorUppercase
            ? message.author.toUpperCase()
            : message.author}
        </Text>
      </div>
    </motion.div>
  );
}

export default AnimatedMessage;
